import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import queryString from "query-string";
import axios from "../../../../../axios-instance";
import ls from 'localstorage-slim';
import Page404 from "../../../../../components/Page404/Page404";

import { clearCurrentEvent, getEvent } from "../../../../../store/actions/eventsActions";

import Upload from "../../../../Upload/Upload";
import { getHeaders } from "../../../../../helpers/getHeaders";
import { loadFile } from "../../../../../helpers/loadFile";
import PleaseWaitModal from "../../../../BarCodes/modals/PleaseWaitModal";
import SingleCheckboxSelector from "../../../../../components/SingleCheckboxSelector";
import { executeAsyncWithModal } from "../../../../../helpers/modal";
import CheckBox from "../../../../../components/UI/Checkbox/CheckBox";
import Icon from "../../../../../components/UI/Icon/Icon";

import "./EventSeats.sass";
import { getCustomURLs } from "../../../../../helpers/getCustomURLs";

const MySwal = withReactContent(Swal);

const MANAGE_SEATS_ACTIONS = [
  {
    value: "/ManageSeatsForSale/AddSeatsForSale",
    label: "Add seats from the file to existing seats",
    fileResult: true,
  },
  {
    value: "/ManageSeatsForSale/SetSeatsForSale",
    label: "Replace existing seats with seats from the file",
    fileResult: true,
  },
  {
    value: "/ManageSeatsForSale/ExcludeSeatsForSale",
    label: "Remove seats from the file from existing seats",
    fileResult: true,
  },
  {
    value: "/ManageSeatsForSale/Reserve",
    label: "Add seats from the file to reserved",
    fileResult: true,
  },
];

class UploadAvailableSeats extends Component {
  state = {
    file: [],
    isFound: true,
    selectedEventActionPath: MANAGE_SEATS_ACTIONS[0].value,
    currentEvent: {},
  };

  static getDerivedStateFromProps(props, state) {
    if (
      props.currentEvent.id &&
      props.currentEvent.id !== state.currentEvent.id
    ) {
      const currentEvent = {
        ...props.currentEvent,
      };
      return {
        currentEvent,
      };
    }
    return null;
  };

  componentDidMount() {
    const {
      user: { token },
      match: { params },
      getEvent,
    } = this.props;

    const action = queryString.parse(this.props.location.search).action;

    if (!this.props.currentEvent.id)
      getEvent(params.id, token, action).then((result) => {
        if (!result.isFound) {
          this.setState({ isFound: false });
        }
      });
  }
  onButtonEnable = (file) => {
    this.setState({
      file,
    });
  };

  downloadTemplateHandler = async () => {
    try {
      if (!navigator.onLine) {
        throw new Error("offline");
      }

      const { SERVER_URL } = getCustomURLs();

      const url = SERVER_URL + "/Files/Static/csv/AvailableSeats.csv";

      const { data } = await executeAsyncWithModal(
        () => axios.get(url),
        <PleaseWaitModal message="Downloading file…" />
      );

      this.downloadDataAsFile(data, "AvailableSeatsTemplate.csv");
    } catch (e) {
      toast.error("File was not downloaded");
      console.log(e);
    }
  };

  downloadAvailableSeatsHandler = async () => {
    try {
      if (!navigator.onLine) {
        throw new Error("offline");
      }

      const user = JSON.parse(localStorage.getItem("user"));
      const { currentEvent } = this.props;

      const request = () =>
        axios.get(`ManageSeatsForSale/${currentEvent.id}/SeatsForSale`, {
          headers: getHeaders(user.token),
        });

      const { data } = await executeAsyncWithModal(
        request,
        <PleaseWaitModal message="Downloading file…" />
      );

      this.downloadDataAsFile(data, `Seats ${currentEvent.name}.csv`);
    } catch (e) {
      toast.error("File was not downloaded");
      console.log(e);
    }
  };

  downloadDuplicatedSeatsHandler = async () => {
    try {
      if (!navigator.onLine) {
        throw new Error("offline");
      }

      const user = JSON.parse(localStorage.getItem("user"));
      const { currentEvent } = this.props;

      const request = () =>
        axios.post(`ManageSeatsForSale/GetDoubles/${currentEvent.id}`, null, {
          headers: getHeaders(user.token),
        });

      const { data } = await executeAsyncWithModal(
        request,
        <PleaseWaitModal message="Downloading file…" />
      );

      this.downloadDataAsFile(data, `Duplicated seats ${currentEvent.name}.csv`);
    } catch (e) {
      toast.error("File was not downloaded");
      console.log(e);
    }
  };

  selectedEventActionChangeHandler = (evt) => {
    this.setState({ selectedEventActionPath: evt.target.name });
  };

  closeFileHandler = () => {
    this.setState({ selectedEventActionPath: MANAGE_SEATS_ACTIONS[0].value });
  };

  removeAllRestrictionsHandler = () =>
    MySwal.fire({
      title: "Are you sure you want to de-restrict?",
      text: "This action will make all seats available",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      confirmButtonText: "De-restrict",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        const { isSuccess } = await this.uploadFile(
          "/ManageSeatsForSale/SetAllSeatsForSale"
        );

        if (isSuccess) {
          toast.success("Restriction removed successfully");
        } else {
          toast.error("Restriction was not removed");
        }
      }
    });

  handleSubmit = async () => {
    const { file } = this.state;

    const body = new FormData();
    body.append("file", file[0]);
    const fileAsResult = MANAGE_SEATS_ACTIONS.find(a => a.value == this.state.selectedEventActionPath).fileResult;

    const { isSuccess, data } = await executeAsyncWithModal(
      () => this.uploadFile(this.state.selectedEventActionPath, body),
      <PleaseWaitModal message={fileAsResult ? "Downloading file…" : "Processing..."} />
    );

    if (fileAsResult) {
      if (isSuccess) {
        this.downloadDataAsFile(data, "NotProcessedSeats.csv");
      } else {
        toast.error("File was not downloaded");
      }
    }
    else {
      if (isSuccess) {
        toast.success("Completed");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  uploadFile = async (eventActionPath, body = null) => {
    //TODO: Should use redux!!!
    let result = {
      data: null,
      isSuccess: false,
    };

    if (!navigator.onLine) {
      return result;
    }

    try {
      const {
        match: { params },
      } = this.props;

      const user = JSON.parse(localStorage.getItem("user"));
      const url = `${eventActionPath}/${params.id}`;

      const { data } = await axios.post(url, body, {
        headers: getHeaders(user.token),
      });

      result = {
        data: data,
        isSuccess: true,
      };
    } catch (e) {
      console.log(e);
    }

    return result;
  };

  downloadDataAsFile = (data, name) => {
    if (data) {
      loadFile(data, name);

      toast.success("File downloaded successfully");
    } else {
      toast.error("Failed to retrieve data");
    }
  };

  handleChangeMapMode = async () => {
    try {
      const { token } = ls.get("user");
      const { id } = this.props.currentEvent;

      const { status, data, error } = await axios.put(
        `/Events/${id}/SwitchMapMode`,
        null,
        {
          headers: getHeaders(token),
        }
      );

      if (status === 200 && Boolean(data.result)) {
        const { ...currentEvent } = this.state.currentEvent;

        currentEvent.isPublicMode = !currentEvent.isPublicMode;

        this.setState((prev) => ({
          ...prev,
          currentEvent,
        }));
      } else {
        throw new Error(error);
      }
    } catch (error) {
      console.log(error);
      toast.error(String(error));
    }
  };

  handleMigrateSeats = async () => {
    try {
      const { token } = ls.get("user");
      const { id } = this.props.currentEvent;

      const request = () =>
        axios.put(`/Events/${id}/MigrateSeats`, null, {
          headers: getHeaders(token),
        });

      const { status, data, error } = await executeAsyncWithModal(
        request,
        <PleaseWaitModal message="The migration from admin to public map in process..." />
      );

      if (status === 200 && Boolean(data.result)) {
        const { ...currentEvent } = this.state.currentEvent;
        currentEvent.isPublicMode = true;

        this.setState((prev) => ({
          ...prev,
          currentEvent,
        }));

        toast.success("Map in public mode now");
      } else {
        throw new Error(error);
      }
    } catch (error) {
      console.log(error);
      toast.error(String(error));
    }
  };

  checkIsDisabled = () => {
    const { file } = this.state;

    return !file || !file.length;
  };

  render() {
    if (!this.state.isFound) {
      return <Page404 />;
    }

    const { currentEvent } = this.state;

    return (
      <div className="new-event__seats seats">
        <a
          className="seats-io-link"
          target="__balnk"
          href={`https://app.seats.io/charts/${currentEvent.hideSeatsIoChartKey}/events/${currentEvent.hideSeatsIoEventId}/forsale`}
        >
          Go to Seats Io (hidden)
        </a>
        <a
          className="seats-io-link"
          target="__balnk"
          href={`https://app.seats.io/charts/${currentEvent.seatsIoChartKey}/events/${currentEvent.seatsIoEventId}/forsale`}
        >
          Go to Seats Io (public)
        </a>
        <div className="download-actions-container">
          <div
            className="seats__download download-action"
            onClick={this.downloadTemplateHandler}
          >
            <Icon name="excel" />
            <button>
              Download template
            </button>
          </div>
          <div
            className="seats__download download-action"
            onClick={this.downloadAvailableSeatsHandler}
          >
            <Icon name="excel" />
            <button>
              Download available seats
            </button>
          </div>
          <div
            className="seats__download download-action"
            onClick={this.downloadDuplicatedSeatsHandler}
          >
            <Icon name="excel" />
            <button>
              Download duplicated seats
            </button>
          </div>
        </div>
        <div className="seats__upload">
          <div className="seats__choose-file">
            <p>Choose the file ( .csv)</p>

            <Upload
              onClose={this.closeFileHandler}
              onButtonEnable={this.onButtonEnable}
            />
          </div>
        </div>

        {!this.checkIsDisabled() && (
          <SingleCheckboxSelector
            className="event-action-selector"
            items={MANAGE_SEATS_ACTIONS}
            selectedValue={this.state.selectedEventActionPath}
            onChange={this.selectedEventActionChangeHandler}
          />
        )}

        <div className="seats-buttons-container">
          <button
            type="button"
            className="seats__de-restrict btn-red-outline"
            onClick={this.removeAllRestrictionsHandler}
          >
            De-restrict
          </button>

          <div className="seats-buttons-container seats-buttons-container--right">
            <CheckBox
              name="isPublicMode"
              id="is-public-mode"
              checked={currentEvent.isPublicMode}
              onChange={this.handleChangeMapMode}
            >
              Map mode: {currentEvent.isPublicMode ? "public" : "hidden"}
            </CheckBox>
            <button
              type="button"
              className="btn-primary"
              onClick={this.handleMigrateSeats}
            >
              <Icon name="plus" />
              <span>Migrate seats</span>
            </button>
            <button
              type="button"
              disabled={this.checkIsDisabled()}
              onClick={this.handleSubmit}
              className="seats__submit btn-primary"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth: { user }, events: { currentEvent } }) => ({
  user,
  currentEvent,
});

const mapDispatchToProps = (dispatch) => ({
  getEvent: (eventId, token, action) => dispatch(getEvent(eventId, token, action)),
  clearCurrentEvent: () => dispatch(clearCurrentEvent()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UploadAvailableSeats)
);
